/*
 * File: cell-ledger-amount.ts
 * Created: 2026-02-03
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellLedgerAmount extends BaseTableBodyCell {
    get amountValue() {
        const raw = this.row?.delta ?? this.value ?? 0;
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    get amountText() {
        const sign = this.amountValue > 0 ? "+" : this.amountValue < 0 ? "-" : "";
        return `${sign}${Math.abs(this.amountValue).toFixed(2)}`;
    }

    get sourceType() {
        return String(this.row?.source ?? "").toUpperCase();
    }

    get variantClass() {
        if (this.sourceType === "USER_DEPOSIT") return "tx-deposit";
        if (this.sourceType === "PROMO_CREDIT") return "tx-deposit";
        if (this.sourceType === "REFUND") return "tx-deposit";
        return "tx-usage";
    }

    get metaText() {
        if (this.sourceType === "REFUND") return this.$_("w_LedgerAmountRefunded");
        return "";
    }
}
